export default __webpack_public_path__ + "static/media/Charts.1a0b95b1.svg";